export class AppConstants {
  // ENV CONFIG
  public static ENVIRONMENT = 'prod'; // local | test | prod
  // API CONFIG
  public static API_BASE_URL_LOCAL = 'http://localhost:8082';
  public static API_BASE_URL_TEST = 'https://test.doctorapp.ro/api';
  public static API_BASE_URL_PROD = 'https://app.doctorapp.ro/api';
}
